<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="toManagement">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">申请时间：</div>
        <div>{{formData.createTime || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">开票类型：</div>
        <div v-if="formData.invoiceType === '1'">正票</div>
        <div v-if="formData.invoiceType === '2'">红票</div>
      </div>
      <div class="form-line">
        <div class="line-text">发票抬头：</div>
        <div>{{formData.receiptTitle || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">发票号码：</div>
        <div>{{formData.receiptNo || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">发票状态：</div>
        <div>{{formData.invoiceStatusText || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">发票备注：</div>
        <div>{{formData.receiptMemo || '无'}}</div>
      </div>

      <div class="form-line" v-if="formData.reasonForInvalidation">
        <div class="line-text">作废原因：</div>
        <div>{{formData.reasonForInvalidation || '无'}}</div>
      </div>

      <div class="form-line">
        <div class="line-text">关联账单：</div>
        <div style="color: #00a0e6;cursor: pointer;" @click="seeBill">查看</div>
      </div>

      <div class="form-line">
        <div class="line-text">发票类型：</div>
        <div>{{formData.receiptType || '无'}}</div>
      </div>

      <div class="form-line">
        <div class="line-text">购方名称：</div>
        <div>{{formData.purchaserName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">购方纳税人识别号：</div>
        <div>{{formData.purchaserTaxpayerIdentificationNumber || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">购方地址：</div>
        <div>{{formData.purchaserAddress || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">购方电话：</div>
        <div>{{formData.purchaserPhone || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">购方开户行：</div>
        <div>{{formData.purchaserBank || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">邮箱：</div>
        <div>{{formData.email || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">发票链接：</div>
        <div v-if="formData.pdfUrl" style="color: #00a0e6;cursor: pointer;" @click="seePdf">查看</div>
        <div v-else>无</div>
      </div>
    </form>


    <el-dialog title="关联账单" :visible.sync="billVisible" width="60%">
      <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" :pagination="false" :hasOperation="false" />
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {api} from '../../api/invoice'
  import {errorHandler} from '../../../utils/errorHandler'
  import TableMain from '../../../components/Table/TableMain'

  export default {
    components: {
      TableMain,
      TextTitle,
      Breadcrumb},
    name: 'invoice-info-current',
    data () {
      return {
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '发票管理'
        }],
        mainTitle: '发票详情',
        subheading: '',
        formData: {},
        serialNo: '',

        billVisible: false,
        tableHead: [{
          prop: 'payer',
          label: '账单主体'
        }, {
          prop: 'billType',
          label: '账单类型',
        }, {
          prop: 'memo',
          label: '账单区间',
        }, {
          prop: 'billAmount',
          label: '账单金额(元)',
        }, {
          prop: 'payTime',
          label: '收款时间'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
      }
    },
    created () {
      this.serialNo = this.$route.params.id
      this.getInvoiceRecordBySerialNo()
    },
    methods: {
      toManagement () {
        this.$router.push({
          name: 'invoice-manage'
        })
      },
      getInvoiceRecordBySerialNo () {
        this.$axios.get(`${api.getInvoiceRecordBySerialNo}/${this.serialNo}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data.invoiceStatus === 'SUCCESS') {
                data.invoiceStatusText = '开票成功'
              } else if (data.invoiceStatus === 'FAIL') {
                data.invoiceStatusText = '开票失败'
              } else if (data.invoiceStatus === 'PENDING') {
                data.invoiceStatusText = '开票中'
              } else if (data.invoiceStatus === 'INVALID') {
                data.invoiceStatusText = '已作废'
              }
              if (data.createTime) {
                data.createTime = data.createTime.slice(0, 19)
              }
              this.formData = data
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 查看PDF
      seePdf () {
        window.open(this.formData.pdfUrl, '_blank')
      },

      // 查看账单
      seeBill () {
        this.billVisible = true
        this.getRelatedRecordList()
      },

      getRelatedRecordList () {
        this.$axios.get(`${api.getRelatedRecordList}/${this.serialNo}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.tableData = data
            }
          })
          .catch(errorHandler('查询失败'))
      },
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  form > div {
    display: flex;
    justify-content: flex-start;
  }
  .form-title {
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    padding-left: 5px;
    border-left: 3px solid #00a0e6;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 140px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceManage/InvoiceInfoCurrent.vue